/**
 * 中台分片导入场景，边转换边加载
 * 需对转换过程中的错误进行处理
 */
import i18n from '@i18next/i18n';
import { CommonTipsType, CommonTipsActionType } from '@src/framework/frame/components/common-tips';

class DetailedError extends Error {
    public details: any;
    public constructor(message, details) {
        super(message);
        this.name = this.constructor.name;
        this.details = details;
        Error.captureStackTrace(this, this.constructor);
    }
}

enum ConvertErrorCode {
    ENCRYPTED_FILE = 402702, // 暂不支持打开加密文档
    LOAD_FAILED = 402704, // 文档解析失败
}

const ERROR_MESSAGE: Record<ConvertErrorCode, string> = {
    [ConvertErrorCode.ENCRYPTED_FILE]: i18n.t('本文档设置了密码，暂不支持预览'),
    [ConvertErrorCode.LOAD_FAILED]: i18n.t('文档解析失败'),
};

export const handleDetailError = (message: string, code: number): DetailedError => new DetailedError(message, {
    code,
    message: ERROR_MESSAGE[code] || i18n.t('预览失败，请刷新重试'),
    actionType: CommonTipsActionType.NONE,
});
